import type { BlokProps } from "@trydig/storyblok";
import { BlokWrap } from "~/components/bloks/BlokWrap";
import { ReactVideoPlayer } from "~/components/bloks/MediaBlok/ReactVideoPlayer";
import { StoryblokImage } from "~/components/bloks/MediaBlok/StoryblokImage";
import { Video } from "~/components/ui/Video";
import type { MediaStoryblok } from "~/generated/sb/blok-types";
import { formatStoryblokMedia } from "~/lib/storyblok/formatStoryblokMedia";
import styles from "./sb-media.module.css";

export const MediaBlok = ({
	blok,
	sizes = "100vw",
	customAspect,
}: BlokProps<MediaStoryblok> & { customAspect?: boolean; sizes?: string }) => {
	const { desktop: desktopMedia, mobile: mobileMedia } = formatStoryblokMedia(blok);

	if (!blok) return null;

	return (
		<BlokWrap
			editable={blok}
			className={styles.wrapper}
			data-only-desktop={!mobileMedia?.isImage && !mobileMedia?.isVideo}
		>
			{desktopMedia && (
				<div className={styles.desktop}>
					{desktopMedia.type === "youtube" || desktopMedia.type === "vimeo" ? (
						<ReactVideoPlayer
							media={{ url: desktopMedia.file ?? "" }}
							shouldAutoPlay={false}
							shouldLoop={false}
						/>
					) : desktopMedia.isVideo ? (
						<Video
							url={desktopMedia.file ?? ""}
							alt={desktopMedia.alt}
							id={desktopMedia._uid}
							width="100%"
							height="100%"
						/>
					) : (
						desktopMedia.isImage && (
							<StoryblokImage
								media={desktopMedia}
								key={desktopMedia.file}
								fill={false}
								width={+(desktopMedia?.width ?? 0)}
								height={+(desktopMedia?.height ?? 0)}
								sizes={sizes}
								customAspect={customAspect}
							/>
						)
					)}
				</div>
			)}
			{mobileMedia && (
				<div className={styles.mobile}>
					{mobileMedia.type === "youtube" || mobileMedia.type === "vimeo" ? (
						<ReactVideoPlayer
							media={{ url: mobileMedia.file ?? "" }}
							shouldAutoPlay={false}
							shouldLoop={false}
						/>
					) : mobileMedia.isVideo ? (
						<Video url={mobileMedia.file ?? ""} alt={mobileMedia.alt} id={mobileMedia._uid} />
					) : (
						mobileMedia.isImage && (
							<StoryblokImage
								media={mobileMedia}
								key={mobileMedia.file}
								fill={false}
								width={+(desktopMedia?.width ?? 0)}
								height={+(desktopMedia?.height ?? 0)}
								sizes={sizes}
								customAspect={customAspect}
							/>
						)
					)}
				</div>
			)}
		</BlokWrap>
	);
};
